export default "__VITE_ASSET__CNPoGDJg__"